declare global {
  interface Window {
    /** Set by browser monitors before any application script executes. */
    __ishSyntheticMonitor?: boolean;
  }
}

/**
 * Fail-closed analytics marker shared by every browser transport.
 *
 * Keep this independent from analytics-server: tests and small client islands
 * routinely mock a transport, but synthetic exclusion is a browser identity
 * concern that must remain available whichever transport is substituted.
 */
export function syntheticTrafficMarker(): { traffic_class: "synthetic" } | Record<string, never> {
  return typeof window !== "undefined" && window.__ishSyntheticMonitor === true
    ? { traffic_class: "synthetic" }
    : {};
}
